import React from "react"
import styled from "styled-components"

// Styling
import colors from "../../../styles/colors"
import textStyles from "../../../styles/textStyles"
import mq from "../../../styles/breakpoints"

interface IProps {
  error?: string
}

const Error: React.FCS<IProps> = ({ error, className }) => (
  <>{!!error && <Container className={className}>{error}</Container>}</>
)

const Container = styled.div`
  ${textStyles.body};
  color: ${colors.red};
  margin-bottom: 0;

  ${mq.from.S`
    margin-bottom: 0;
  `}
`

export default Error
